import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { usePlanPageVariant } from "@/react/hooks/usePlanPageVariant";

interface PlanSummaryContainerProps {
  children: React.ReactNode;
}

export const PlanSummaryContainer = ({
  children,
}: PlanSummaryContainerProps) => {
  const { isCompactLayout } = usePlanPageVariant();

  return (
    <div
      className={classNames(
        "border-primary bg-primary flex flex-col gap-y-5 rounded-xl border p-6",
        isCompactLayout ? "w-[325px]" : "w-[375px]",
      )}
    >
      {children}
    </div>
  );
};
